// IMPORTANT: add loadable for to check if we are on mobile becayse the topOffset={80} might change

import { Image } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import Sticky from 'react-sticky-el';
import Button from '../Shared/components/controls/Button/index.js';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js'; //https://github.com/dozoisch/react-google-recaptcha
import './style.scss';
import clsx from 'clsx';
const StickyNavigation = (props) => {
  if (!props?.fields || !props.params) {
    return <GenericPlaceholder componentName="StickyNavigation" />;
  }

  const { logo, items, link } = props?.fields;
  const shouldRenderLogo = !!logo?.value?.src;
  const shouldRenderLink = !!link?.value?.href;
  const shouldRenderBredCrumb = Array.isArray(items) && items.length > 0;

  const openSearchPopup = () => {
    //  to open the search popup
    document.getElementById('search-popup-id').classList.add('show-search-popup');
    document.body.classList.add('filter-modal-open');
  };

  const IsEliteTheme = props?.fields?.IsEliteTheme?.value;
  return (
    <Sticky
      className={clsx('header-sticky-nav', IsEliteTheme ? 'theme-elite' : 'theme-default')}
      boundaryElement=".main-body"
    >
      <div className="content-wrap">
        <div className="content">
          <div className="app-header-top-row ahtr-pc">
            <div className="ahtr-half">
              {shouldRenderLogo && (
                <a className="logo">
                  <Image field={logo} />
                </a>
              )}
              <div className="search" onClick={openSearchPopup}>
                <img
                  alt="search"
                  className="search-icon"
                  src="/-/jssmedia/Project/FAB2/Fab2/data/media/svgs/icons/search.svg?iar=0&amp;hash=847BAB1B619F4E9239A3EE939E5081A5"
                />
              </div>

              {shouldRenderBredCrumb && (
                <div className="bredcrumbs flex-it flex-align-item-center">
                  {items?.map((bred, index) => {
                    const showArrow = index !== items?.length - 1;

                    return (
                      <a
                        href={bred?.url}
                        className="bred flex-inline flex-align-item-center"
                        key={index}
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {bred?.displayName || bred?.fields?.pageTitle?.value}{' '}
                        {showArrow && (
                          <span className="arrow-bred flex-inline flex-align-item-center">
                            <img src="/-/media/Project/FAB2/shared/images/icon_bred_arrow.svg" />
                          </span>
                        )}
                      </a>
                    );
                  })}
                </div>
              )}
            </div>
            <div className="ahtr-half">{shouldRenderLink && <Button link={link} />}</div>
          </div>
        </div>
      </div>
    </Sticky>
  );
};

export default StickyNavigation;
